import React from "react";
import "./cookieconsent.css";

const CookieConsent = ({
    getMixpanelTrackingStatus,
    termsConditionsURL,
    handleCookieAllowance,
  }) => {
  return (
    <>
    <div className="cookie-consent" id="cookie-consent-banner" hidden={getMixpanelTrackingStatus}> 
            <span>This site uses cookies to enhance the user experience. By continuing to use the site, you agree to the use of cookies. 
              <a href={termsConditionsURL} className="ml-1 text-decoration-none">More Info</a>   
            </span>
            <div className="mt-2 d-flex align-items-center justify-content-center g-2"> 
              <button 
                id="cookie-consent-ok-button"
                className="allow-button mr-1"
                onClick={handleCookieAllowance}
                >
                Ok, got it!
              </button> 
            </div>
          </div>
    </>
  );
};

export default CookieConsent;